
export default {
    me() {
        return window.restApi.get('user/my');
    },
    mypermission() {
        return window.restApi.get('user/my/permission');
    },
    myresetpassword(model, config) {
        return window.restApi.post('v2/user/my/resetpassword', model, config);
    },
    myresetpin(model, config) {
        return window.restApi.post('v2/user/my/resetpin', model, config);
    },
    uploadPhoto(model, config) {
        return window.restApi.post('v2/user/my/photo', model, config);
    },
    uploadSignature(model, config) {
        return window.restApi.post('v2/user/my/signature', model, config);
    },
    userList(model) {
        return window.restApi.get('/v2/user/user/list', {params: model});
    },
    getUser(id) {
        return window.restApi.get('v2/user/user/get/' + id);
    },
    saveUser(model, config) {
        if (model.id) {
            return window.restApi.post('v2/user/user/update', model, config);
        } else {
            return window.restApi.post('v2/user/user/save', model, config);
        }
    },
    deleteUser(model, config) {
        return window.restApi.post('v2/user/user/delete', model, config);
    },
    resetPasswordUser(model, config) {
        return window.restApi.post('v2/user/user/resetpassword', model, config);
    },
    resetPinUser(model, config) {
        return window.restApi.post('v2/user/user/resetpin', model, config);
    },
    roleList(model) {
        return window.restApi.get('v2/user/role/list', {params: model});
    },
    roleGet(id) {
        return window.restApi.get('v2/user/role/get/' + id);
    },
    saveRole(model, config) {
        if (model.id) {
            return window.restApi.post('v2/user/role/update', model, config);
        } else {
            return window.restApi.post('v2/user/role/save', model, config);
        }
    },


    updateMe(model, config) {
        return window.restApi.post('user/my/update', model, config);
    },
    changePassword(model, config) {
        return window.restApi.post('user/my/changepassword', model, config);
    },
    myDashboard() {
        return window.restApi.get('dashboard/my');
    },
}
